export default defineNuxtRouteMiddleware(async (to) => {
  if (to.matched.length === 0) {
    const { data: currentSite } = await useApi("/api/sites")
    const notFoundUrl = currentSite.value?.notFoundUrl
    if (notFoundUrl) {
      return navigateTo(notFoundUrl, {
        external: true,
        redirectCode: 302,
      })
    }
    // Without a per-site notFoundUrl, return a clean 404 instead of letting
    // the undefined access throw and surface as 500.
    throw createError({ statusCode: 404, statusMessage: "Not Found" })
  }
})
